module.exports = __webpack_public_path__ + "static/img/cont45_03.db6be15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45_03.jpg
// module id = /T77
// module chunks = 0